/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How often a streak window resets
 * @export
 */
export const StreakCadence = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    CUSTOM: 'CUSTOM'
} as const;
export type StreakCadence = typeof StreakCadence[keyof typeof StreakCadence];


export function instanceOfStreakCadence(value: any): boolean {
    for (const key in StreakCadence) {
        if (Object.prototype.hasOwnProperty.call(StreakCadence, key)) {
            if (StreakCadence[key as keyof typeof StreakCadence] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StreakCadenceFromJSON(json: any): StreakCadence {
    return StreakCadenceFromJSONTyped(json, false);
}

export function StreakCadenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakCadence {
    return json as StreakCadence;
}

export function StreakCadenceToJSON(value?: StreakCadence | null): any {
    return value as any;
}

export function StreakCadenceToJSONTyped(value: any, ignoreDiscriminator: boolean): StreakCadence {
    return value as StreakCadence;
}

